import axios from 'axios'
import store from '../../store/index'

const state = {
  appConfigurations: [],
  appConfigurationActions: [],
  appConfigurationTypes: [],
}

const mutations = {
  appConfigurations_data (state, appConfigurations) {
    state.appConfigurations = appConfigurations
  },
  appConfigurationActions_data (state, appConfigurationActions) {
    state.appConfigurationActions = appConfigurationActions
  },
  appConfigurationTypes_data (state, appConfigurationTypes) {
    state.appConfigurationTypes = appConfigurationTypes
  },
}

const actions = {
  createAppConfiguration ({ commit }, appConfiguration) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/appConfiguration',
        data: appConfiguration,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  updateAppConfiguration ({ commit }, appConfiguration) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/appConfiguration?id=' + appConfiguration.appConfigurationId,
        data: { message: appConfiguration.message },
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  deleteAppConfiguration ({ commit }, appConfigurationId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/appConfiguration?id=' + appConfigurationId,
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getAppConfigurations ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/appConfiguration',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          commit('appConfigurations_data', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getAppConfigurationsActions ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/appConfiguration/actions',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          commit('appConfigurationActions_data', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getAppConfigurationsTypes ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/appConfiguration/types',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          commit('appConfigurationTypes_data', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
